import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { screenSizes } from '../Literals';

export const registrationFormLayoutStyles = css`
  padding: 20px;

  .Registration__input {
    width: 33%;
  }

  .ccf-form .Registration__input,
  .ccf-form .ui.input,
  .ccf-form .ui.selection.dropdown {
    width: 100% !important;
    display: block !important;
    margin: 0 !important;
  }

  .ccf-form .dropdown {
    width: 100% !important;
    margin-top: 0;
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    max-width: 100%;

    .Registration__input,
    input,
    .input {
      display: block;
      width: 100% !important;
    }
  }
`;

export const RegistrationSection = styled.section`
  background-color: #fff;
  border-radius: 22px;
  height: auto;
  max-width: 80vw;
  padding: 1.1rem;

  .Registration__title {
    color: #2596c2;
    font-size: 2.5rem;
  }

  .Registration__input {
    padding: 0.3rem 0.5rem 0.3rem 1rem;
    font-size: 20px;
    border-radius: 22px;
    border: none;
    margin: 0.1rem auto;
    &::placeholder {
      color: #a3a3a3;
    }
  }

  .Registration__form {
    text-align: center;
    ${registrationFormLayoutStyles}

    .dropdown {
      width: 30%;
      margin-top: 15px;
    }

    .ccf-form .dropdown {
      width: 100%;
      margin-top: 0;
    }
  }

  .Registration__tags {
    p {
      margin: 5px 0 0 0;
    }
    .dia {
      h3 {
        margin: 10px 0;
      }
      width: 40%;
      display: inline-block;
    }
  }
`;

export const RegistrationForm = styled.form`
  ${registrationFormLayoutStyles}
  text-align: center;

  .legal {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 14px;
    padding: 1rem 1.15rem;
    margin: 1.5rem 0;
    text-align: left;

    @media only screen and (max-width: ${screenSizes.mobile}) {
      padding: 0.7rem 0.8rem;
      margin: 0.85rem 0;
      border-radius: 10px;
    }

    &.error {
      border-color: #e0b4b4;
      background: #fff6f6;
    }

    .legal-header {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;
    }

    .ui.checkbox label {
      font-weight: 700;
      font-size: 0.95rem;
      color: #1a1a1a;
      line-height: 1.4;

      &::before {
        border-radius: 4px;
      }
    }

    .legal-text {
      margin: 0.5rem 0 0 1.85rem;
      font-size: 0.82rem;
      line-height: 1.55;
      color: #666;

      @media only screen and (max-width: ${screenSizes.mobile}) {
        margin: 0.35rem 0 0 1.5rem;
        font-size: 0.74rem;
        line-height: 1.4;
      }

      a {
        color: #2185d0;
      }
    }
  }
`;
